import { AxiosResponse } from 'axios';

import { api } from '../../http';
import {
  BaseFilter,
  ObjectForSelection,
  PageRequest,
  PageResponse
} from '../../types/interfaces';
import { GeographicalZone } from '../../types/interfaces/GeographicalZone';

import { ApiResponse } from './interfaces';

export const GeographicalZoneService = {
  getGeographicalZones(
    params: PageRequest & {
      sortBy?: string;
      sortDirection?: string;
      parsedFilters?: BaseFilter[];
      fillers?: string;
      filters?: string;
    }
  ): Promise<AxiosResponse<PageResponse<GeographicalZone> | undefined>> {
    const searchParams = new URLSearchParams();
    Object.keys(params).forEach((key) => {
      const value = (params as any)[key];
      if (value) {
        searchParams.append(key, String(value));
      }
    });

    return api
      .get<ApiResponse<PageResponse<GeographicalZone>>>('GeographicalZone', {
        params: searchParams
      })
      .then((resp) => {
        if (resp.data.isSuccess) {
          return { ...resp, data: resp.data.value };
        }
        return { ...resp, data: undefined };
      });
  },

  getGeographicalZonesForSelection(): Promise<
    AxiosResponse<ApiResponse<ObjectForSelection[]>>
  > {
    return api.get<ApiResponse<ObjectForSelection[]>>('GeographicalZone', {
      params: { ForSelection: 'true' }
    });
  },

  getGeographicalZoneById(
    id: number
  ): Promise<AxiosResponse<GeographicalZone | undefined>> {
    return api
      .get<ApiResponse<GeographicalZone>>(`GeographicalZone/${id}`)
      .then((resp) => {
        if (resp.data.isSuccess) {
          return { ...resp, data: resp.data.value };
        }
        return { ...resp, data: undefined };
      });
  },

  createGeographicalZone(
    geographicalZone: GeographicalZone
  ): Promise<AxiosResponse<ApiResponse<GeographicalZone>>> {
    return api.post<ApiResponse<GeographicalZone>>(
      'GeographicalZone',
      geographicalZone
    );
  },

  updateGeographicalZone(
    id: number,
    geographicalZone: GeographicalZone
  ): Promise<AxiosResponse<ApiResponse<GeographicalZone>>> {
    return api.put<ApiResponse<GeographicalZone>>(
      `GeographicalZone/${id}`,
      geographicalZone
    );
  },

  deleteGeographicalZone(
    id: number
  ): Promise<AxiosResponse<ApiResponse<null>>> {
    return api.delete<ApiResponse<null>>(`GeographicalZone/${id}`);
  }
};

